export default __webpack_public_path__ + "static/media/faq_flower_1.08a516d2.webp";